import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IInformation } from '../../../../interfaces/Information.interfaces';

interface InfoHorizontalListSummaryViewProps {
  information: IInformation;
}

export const InfoHorizontalListSummaryView = ({ information }: InfoHorizontalListSummaryViewProps) => {
  const navigate = useNavigate();

  return (
    <Container onClick={() => navigate(`/info/${information.id}`)}>
      <ThumbnailImage src={information.thumbnailUrl} loading={'lazy'} />

      <InformationSection>
        <InformationTopSection>
          {information.category === 'NEWS' && <NewsCategory>{'뉴스'}</NewsCategory>}
          {information.category === 'MAGAZINE' && <MagazineCategory>{'매거진'}</MagazineCategory>}
          <SplitBar>{'|'}</SplitBar>
          <Title>{information.title}</Title>
        </InformationTopSection>
        <PreviewContent>{information.previewContent}</PreviewContent>
      </InformationSection>

      <GoToButton>
        <svg xmlns={'http://www.w3.org/2000/svg'} width={'8'} height={'13'} viewBox={'0 0 8 13'} fill={'none'}>
          <path
            d={
              'M1.26999 12.1699C1.05999 12.1699 0.849986 12.0999 0.709986 11.9599C0.429986 11.6799 0.499986 11.2599 0.779986 10.9799L5.74999 6.63989L0.779986 2.15989C0.499986 1.87989 0.429986 1.45989 0.709986 1.17989C0.989986 0.899889 1.40999 0.829888 1.68999 1.10989L7.28999 6.00989C7.42999 6.14989 7.49999 6.35989 7.49999 6.56989C7.49999 6.77989 7.42999 6.98989 7.28999 7.12989L1.68999 12.0299C1.54999 12.0999 1.40999 12.1699 1.26999 12.1699Z'
            }
            fill={'#858894'}
          />
        </svg>
      </GoToButton>
    </Container>
  );
};

const Container = styled.div`
  width: 300px;

  display: flex;
  align-items: center;

  padding: var(--radius-large, 16px);
  gap: var(--radius-large, 16px);

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const ThumbnailImage = styled.img`
  min-width: 61px;
  max-width: 61px;
  min-height: 61px;
  max-height: 61px;

  border-radius: var(--radius-medium, 8px);
  background: #c4c4c4;

  object-fit: cover;
`;

const InformationSection = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 8px;
`;

const InformationTopSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  gap: 4px;
`;

const Category = styled.span`
  /* System/Medium/m-bold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 11.9px */
`;

const NewsCategory = styled(Category)`
  color: var(--light-scheme-color-primary-blue, #196eff);
`;

const MagazineCategory = styled(Category)`
  color: var(--light-scheme-color-primary-red, #ff3049);
`;

const SplitBar = styled.span`
  color: var(--Light-Scheme-Monochrome-grey30, #d5d5e3);

  /* System/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 11.9px */
`;

const Title = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;

  overflow: hidden;
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-overflow: ellipsis;

  /* System/Medium/m-bold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 11.9px */
`;

const PreviewContent = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;

  overflow: hidden;
  color: var(--Light-Scheme-Monochrome-grey100, #858894);
  text-overflow: ellipsis;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;

const GoToButton = styled.button`
  min-width: 14px;
`;
